import React from 'react'
import { LOCALES, useI18n } from 'i18n'

// Two-option toggle (ES / EN). `tone` adapts it to the brand header or a light page.
const LanguageSwitcher = ({ tone = 'dark' }) => {
  const { locale, setLocale, t } = useI18n()
  const base = tone === 'dark' ? 'ring-white/20' : 'ring-slate-300 bg-white'
  const active = tone === 'dark' ? 'bg-white text-ink' : 'bg-ink text-white'
  const idle = tone === 'dark' ? 'text-white/70 hover:text-white' : 'text-slate-600 hover:text-ink'
  return (
    <div role='group' aria-label={t('app.language')} className={`inline-flex gap-0.5 rounded-lg p-0.5 text-xs font-semibold ring-1 ${base}`}>
      {LOCALES.map((l) => (
        <button key={l.code} type='button' onClick={() => setLocale(l.code)} title={l.label}
          aria-pressed={locale === l.code} className={`rounded-md px-2 py-1 transition-colors ${locale === l.code ? active : idle}`}>
          {l.short}
        </button>
      ))}
    </div>
  )
}

export default LanguageSwitcher
